<!--<input type="file" (change)="onFileSelected($event)">-->
<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(255,255,255,0.8)" size="large" color="#0058ff" type="ball-scale-pulse" [fullScreen]="true">
    <img src="./assets/images/loading04.gif" alt="loading" style="width: 300px;" />
    <!-- <p style="color: black" class="card-title">กำลังโหลดข้อมูล...</p> -->
</ngx-spinner>
<!-- content -->
<div class="content-wrapper" style="min-height: 307px">
    <div class="col-lg-12">
        <!-- แบบค้นหาข้อมูล -->
        <div class="card no-print">
            <div class="card-header bg-purple">
                <i class="fas fa-clipboard-list"></i>
                อัพโหลดไฟล์
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                        <i class="fas fa-minus"></i>
                    </button>
                </div>
            </div>

            <div class="card-body">
                <div class="row">
                    <div class="col"></div>
                    <div class="col-md-2 text-center">
                        <mat-form-field appearance="fill">
                            <mat-label>เลือกปี</mat-label>
                            <mat-select disableRipple required [(ngModel)]="sYear" (ngModelChange)="selectYear()">
                                <mat-option *ngFor="let item of listYear" [value]="item">
                                    ปีการผลิต - {{item[2]}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-2 text-center">
                        <mat-form-field class="example-full-width" appearance="fill">
                            <mat-label>โควตา10หลัก</mat-label>
                            <input matInput required placeholder="รหัสชาวไร่ 10 หลัก" [(ngModel)]="fmcode"
                                maxlength="10" name="fmcode">
                        </mat-form-field>
                    </div>
                    <div class="col-md-2 text-center">
                        <div class="button-row">
                            <button mat-raised-button color="primary" (click)="famerData()"
                                [disabled]="fmcode.length!=10 || sYear.length==0">
                                ตกลง/รีเฟรช
                            </button>
                        </div>
                    </div>
                    <!--<div class="col-md-2 text-center">
                        <input type="file" multiple (change)="onFileChange($event)" accept="application/pdf">
                    </div>-->
                    <div class="col"></div>
                </div>
                <hr />
                <div class="row">
                    <div class="col"></div>
                    <div class="col-md-10">
                        <div *ngFor="let fm of famerdl;">
                            <b>โควตา: {{fm.fmcode}}, โควตาb1: {{fm.fmcode_b1}}, ชื่อ: {{fm.fmname}}, โซน:
                                {{fm.SUPZONE}},
                                นสส: {{fm.SUPCODE}}</b>
                        </div>
                        <div class="example-label">{{DataList.length}} : รายการ </div>
                        <table class="table table-bordered table-sm">
                            <thead>
                                <tr style="text-align:center">
                                    <th>.</th>
                                    <th>ปี</th>
                                    <th>วันที่บันทึก</th>
                                    <th>ขื่อ</th>
                                    <th>ผู้อัพโหลดไฟล์</th>
                                    <th>หมายเหตุ</th>
                                    <th>ไฟล์</th>
                                    <th>ยกเลิก</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style="text-align:center" *ngFor="let dt of DataList; index as i;">
                                    <td> {{i+1}}</td>
                                    <td> {{dt.year}}</td>
                                    <td> {{THtoLocal(dt.dateAdd)}}</td>
                                    <td style="text-align:left"> {{dt.fmname}}</td>
                                    <td style="text-align:left"> {{dt.supname}}</td>
                                    <td style="text-align:left"> {{dt.doc}}</td>
                                    <td>
                                        <a mat-mini-fab href="{{dt.link}}" target="_blank" *ngIf="dt.link">
                                            <mat-icon>picture_as_pdf</mat-icon>
                                        </a>
                                    </td>
                                    <td>
                                        <button mat-icon-button color="warn" (click)="cancel_to(dt)"
                                            [disabled]="!editer" aria-label="ยกเลิกข้อมูล">
                                            <mat-icon>highlight_off</mat-icon>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col"></div>
                </div>


                <hr />
                <form *ngIf="editer&& famerdl.length>0">
                    <div class="row">
                        <div class="col"></div>
                        <div class="col-md-2 text-center">
                            <div class="form-group">
                                <label for="exampleFormControlFile1"> file for {{fm_select[1]}} </label>
                                <input mat-raised-button type="file" multiple class="form-control-file"
                                    id="exampleFormControlFile1" type="file" accept="application/pdf"
                                    (change)="onFileSelected($event)">
                                <a *ngIf="url_load" href={{url_load}} target="_blank">
                                    -ไฟล์ที่อัพโหลด- <i class="fas fa-file-download nav-icon"></i>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-4 text-center">
                            <mat-form-field class="example-full-width" appearance="fill">
                                <mat-label>หมายเหตุ</mat-label>
                                <input matInput required placeholder="..ระบุหมายเหตุ..(ต้องมี)" [(ngModel)]="doc"
                                    maxlength="200" name="doc">
                            </mat-form-field>
                        </div>
                        <div class="col-md-2 text-center">
                            <div class="button-row">
                                <button mat-raised-button color="primary" (click)="insert_to()"
                                    [disabled]="!url_load || !doc">
                                    บันทึกข้อมูล
                                </button>
                            </div>
                        </div>
                        <div class="col"></div>
                        <div class="text-center" *ngIf="isUploading">
                            <div class="spinner-border text-success" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <p>กำลังอัพโหลดไฟล์...</p>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>



<app-footer></app-footer>